import * as React from 'react';

function Logout(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={19} height={17} viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.375 16.125h2.25c.598 0 1.125-.492 1.125-1.125 0-.598-.527-1.125-1.125-1.125h-2.25A1.11 1.11 0 012.25 12.75v-9c0-.598.492-1.125 1.125-1.125h2.25c.598 0 1.125-.492 1.125-1.125C6.75.902 6.223.375 5.625.375h-2.25A3.354 3.354 0 000 3.75v9a3.354 3.354 0 003.375 3.375zm14.344-8.473l-5.063-4.78c-.246-.247-.597-.282-.914-.177a.843.843 0 00-.492.774V6h-4.5c-.633 0-1.125.527-1.125 1.125v2.25A1.11 1.11 0 006.75 10.5h4.5v2.531c0 .317.176.633.492.774.317.105.668.07.914-.176l5.063-4.781c.351-.282.351-.88 0-1.196z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Logout;
